import http from '../jslibs/axios/http';


//获取所有路由列表
export const routerlist = () => (http.post('/v1/cms/AdminAuthMenu/selectList'));

//创建路由

export const newrouter = (data) => (http.post('/v1/cms/AdminAuthMenu', data));